import bem from 'utils/bem';

export const block = bem('clip-video-step');
